import { Combobox, Group, Text } from '@mantine/core'
import { IconX } from '@tabler/icons-react'

/** Sentinel `Combobox.Option` value meaning "clear the current selection". */
export const CLEAR_OPTION_VALUE = '__clear__'

/** "Clear selection" row for the top of an inline code-picker dropdown. */
export function ClearSelectionOption() {
  return (
    <Combobox.Option value={CLEAR_OPTION_VALUE}>
      {/* Flex row so the icon stays inline — Tailwind Preflight defaults <svg> to display:block */}
      <Group gap={6} wrap="nowrap" c="dimmed">
        <IconX size={14} />
        <Text size="sm">Clear selection</Text>
      </Group>
    </Combobox.Option>
  )
}
